import React from "react";
import * as animationData from "./Success_lottie.json";
import "./Success_lottie.css";
import Lottie from "react-lottie";

export const Success_lottie = () => {
  const defaultOptions = {
    loop: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <section className="main">
      <div className="success_div">
        <Lottie className="me-auto" options={defaultOptions} />
      </div>
    </section>
  );
};
